"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiniMap = exports.miniMapYawEventString = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const maps_api_1 = require("maps-api");
const react_1 = require("react");
const MinimapPoint_1 = __importDefault(require("./MinimapPoint"));
const react_ui_1 = require("@pasport/react-ui");
const projection_1 = require("../../projection");
const PanoramaMiniMarker_1 = __importDefault(require("./PanoramaMiniMarker"));
const mapObject2 = (0, maps_api_1.createMap)({
    projection: projection_1.projection
});
exports.miniMapYawEventString = "miniMapYawEvent";
function MiniMap({ width = 200, height = 200 }) {
    const [MapContainer, map] = (0, maps_api_1.useMap)(mapObject2);
    const { location, yaw: y, url, list, open } = (0, maps_api_1.usePanorama)();
    const [firstKnowLocation, setFirstKnowLocation] = (0, react_1.useState)(true);
    const panoramaPoint = (0, react_1.useMemo)(() => {
        if (!list)
            return null;
        return list.find((p) => p.url === url) || null;
    }, [url, list]);
    const [targetPanoramaPointDirection, setTargetDirection] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const t = () => {
            if (!panoramaPoint)
                return;
            function shortAngleDist(a0, a1) {
                var max = Math.PI * 2;
                var da = (a1 - a0) % max;
                return ((2 * da) % max) - da;
            }
            function angleLerp(a0, a1, t) {
                return a0 + shortAngleDist(a0, a1) * t;
            }
            let newTargetDirection = angleLerp((targetPanoramaPointDirection / 180) * Math.PI, (panoramaPoint.direction / 180) * Math.PI, 0.05);
            newTargetDirection = (newTargetDirection / Math.PI) * 180;
            setTargetDirection(newTargetDirection);
        };
        t();
    }, [panoramaPoint, targetPanoramaPointDirection]);
    const yaw = (0, react_1.useMemo)(() => {
        const offset = targetPanoramaPointDirection;
        return y + (offset / 180) * Math.PI;
    }, [y, targetPanoramaPointDirection]);
    const marker = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        window.dispatchEvent(new CustomEvent(exports.miniMapYawEventString, {
            detail: yaw
        }));
    }, [yaw]);
    (0, react_1.useEffect)(() => {
        if (!map.initialized)
            return;
        if (!list)
            return;
        const markers = list.map((p) => {
            return map
                .createMarker(p.location, (marker, map) => {
                return ((0, jsx_runtime_1.jsx)(MinimapPoint_1.default, { map: map, onClick: () => {
                        open(p.url);
                    } }));
            })
                .initialize();
        });
        return () => {
            markers.forEach((m) => m.delete());
        };
    }, [map, list]);
    (0, react_1.useEffect)(() => {
        if (!map.initialized)
            return;
        if (!location)
            return;
        marker.current?.setLocation(location);
        if (firstKnowLocation)
            map.map.setView(location, map.map.getMaxZoom() - 2);
        else
            map.map.setView(location, map.map.getZoom());
        setFirstKnowLocation(false);
    }, [location, map]);
    (0, react_1.useEffect)(() => {
        if (!map.initialized)
            return;
        marker.current = map
            .createMarker(location || [0, 0], (marker, map) => {
            return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(PanoramaMiniMarker_1.default, { initYaw: yaw, onClick: () => {
                        map.flyTo(marker.getLocation(), map.getMaxZoom() - 2);
                    } }) }));
        })
            .initialize();
        marker.current.getLeafletMarker().setZIndexOffset(1000);
        return () => {
            marker.current?.delete();
        };
    }, [map]);
    return ((0, jsx_runtime_1.jsx)(react_ui_1.Card, { children: (0, jsx_runtime_1.jsx)("div", { style: {
                width: width,
                height: height
            }, children: (0, jsx_runtime_1.jsx)(MapContainer, { style: {
                    width: "100%",
                    height: "100%"
                } }) }) }));
}
exports.MiniMap = MiniMap;
